// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

import React from "react";
import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { Typeset, Typepad } from "../Partials/Typeset";
import { Button, ButtonSecondary, ButtonSet } from "../Partials/Button";
import {
  sizes,
  zindex,
  breakpoints,
  typeSet,
  uppercase,
  expandValue,
  transition
} from "../../helpers/theme";


import JesseResume from "../../images/Jesse-Stewart-Resume.pdf";

var tinycolor = require("tinycolor2");

let uiContainerStyles = props => css`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
`;
let UiContainerStyled = styled("div")`
  ${uiContainerStyles}
`;
let uiStyles = props => css`
  position: absolute;
  min-height: 100vh;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
`;
let UiStyled = styled("main")`
  ${uiStyles}
`;
let year = new Date().getFullYear();

export class Ui extends React.Component {
  render() {
    return (
      <UiContainerStyled>
        <UiStyled role="main" id="Main">
          {this.props.children}
          <Copyright>
            2.0.2
            &copy;&nbsp;{year} by Jesse Stewart
          </Copyright>
        </UiStyled>
      </UiContainerStyled>
    );
  }
}

let ContactStyles = props => css`
  .svg-inline--fa {
    margin-right: ${expandValue(sizes.space * 0.25)};
    color: ${tinycolor(props.theme.colors.primary).toString()};
    ${transition("color", sizes.timer + "ms")}
  }
  a:hover .svg-inline--fa {
    color: ${tinycolor(props.theme.colors.secondary).toString()};
  }
`;
let ContactStyled = styled("div")`
  ${ContactStyles}
`;

export class ContactInfo extends React.Component {
  render() {
    let em = "";
    if (this.props.em) {
      em = this.props.em;
    }
    let omit = "";
    if (this.props.omit) {
      omit = this.props.omit;
    }
    return (
      <ContactStyled className="contact-info">
        {omit.indexOf("email") === -1 && (
          <React.Fragment>
            {em === "email" ? (
              <p className="lead">
                <a
                  href="mailto:jesse@jessestewart.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  jesse@jessestewart.com
                </a>
              </p>
            ) : (
              <React.Fragment>
                <a
                  href="mailto:jesse@jessestewart.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  jesse@jessestewart.com
                </a>
                <br />
              </React.Fragment>
            )}
          </React.Fragment>
        )}
        {omit.indexOf("linkedin") === -1 && (
          <React.Fragment>
            <a
              href="http://www.linkedin.com/in/jesse-stewart-1450017/"
              target="_blank"
              rel="noopener noreferrer"
            >
              /jesse-stewart-1450017
            </a>
            <br />
          </React.Fragment>
        )}
        {omit.indexOf("resume") === -1 && (
          <React.Fragment>
            <a href={JesseResume} target="_blank" rel="noopener noreferrer">
              Resume PDF
            </a>
            <br />
          </React.Fragment>
        )}
        {omit.indexOf("portfolio") === -1 && (
          <React.Fragment>
            <a href="https://jessestewart.com" rel="noopener noreferrer">
              Portfolio
            </a>
          </React.Fragment>
        )}
      </ContactStyled>
    );
  }
}

export class Footer extends React.Component {
  render() {
    return (
      <div id="Footer">
        <Typepad
          style={{
            textAlign: "left",
            minHeight: "100vh",
            display: "flex",
            alignItems: "center"
          }}
        >
          <Typeset>
            <h1 className="line">Like what you see?</h1>
            <p
              className="text-lg"
              style={{ marginBottom: expandValue(sizes.space) }}
            >
              I'm currently looking to meet industry professionals and expand my network. If that sounds like you, let's talk!
            </p>
            <ButtonSet>
              <Link to="/contact">
                <Button>Get In Touch</Button>
              </Link>
              <Link to={JesseResume} target="_blank" rel="noopener noreferrer">
                <ButtonSecondary>
                  Resume PDF
                </ButtonSecondary>
              </Link>
            </ButtonSet>
            <ContactInfo />
          </Typeset>
        </Typepad>
      </div>
    );
  }
}

let copyrightStyles = props => css`
  position: absolute;
  bottom: 0;
  right: 0;
  height: ${expandValue(sizes.space * 2)};
  z-index: ${zindex.hud};
  padding: 0 ${expandValue(sizes.space)};
  ${typeSet(sizes.fontSize * 0.75)}
  ${uppercase()}
  font-weight: 100;
  display: flex;
  align-items: center;
  .copyright-link {
    margin-right: ${expandValue(sizes.space)};
    ${transition("all", sizes.timer + "ms")}
    text-decoration: none;
  }
  @media (min-width: ${expandValue(breakpoints[3])}) {
    height: ${expandValue(sizes.space * 4)};
    padding: 0 ${expandValue(sizes.space * 2)};
  }
`;
let CopyrightStyled = styled("footer")`
  ${copyrightStyles}
`;

export class Copyright extends React.Component {
  render() {
    return (
      <CopyrightStyled role="contentinfo" id="footer" className="copyright">
        {this.props.children}
      </CopyrightStyled>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Partials/Ui.js